import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { DialogProps } from "../../misc/DialogProps";
import { DialogCloseButton } from "../../misc/DialogCloseButton";
import { DrivingLicenseAuthorityFormForm } from "./DrivingLicenseAuthorityFormForm";
import { CreateBase, useGetRecordId } from "react-admin";
import { useQueryClient } from "react-query";

export function AddDrivingLicenseAuthorityFormDialog(dialogProps: DialogProps) {
  const authorityId = useGetRecordId();
  const queryClient = useQueryClient();

  return (
    <Dialog {...dialogProps}>
      <DialogTitle>Formular hinzufügen</DialogTitle>
      <DialogCloseButton onClick={dialogProps.onClose} />
      <DialogContent>
        <CreateBase
          resource="drivingLicenseAuthorityForms"
          mutationOptions={{
            onSuccess: async () => {
              await queryClient.invalidateQueries(["drivingLicenseAuthorities"]);
              dialogProps.onClose();
            },
          }}
          transform={(formValues) => ({ authorityId, ...formValues })}
        >
          <DrivingLicenseAuthorityFormForm mode="create" />
        </CreateBase>
      </DialogContent>
    </Dialog>
  );
}
